import { render, staticRenderFns } from "./TableWithDrawer.vue?vue&type=template&id=bc704696&scoped=true&"
import script from "./TableWithDrawer.vue?vue&type=script&lang=js&"
export * from "./TableWithDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TableWithDrawer.vue?vue&type=style&index=0&id=bc704696&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc704696",
  null
  
)

export default component.exports